import React from 'react';
import Icon from 'jitsi/base/icons/components/Icon';
import { IconDownload } from 'jitsi/base/icons/svg';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'absolute',
        top: 0,
        right: 0,
        transform: 'translate(25%, -25%)',
        visibility: "hidden",
        background: theme.palette.iisightWhiteBackground,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        boxShadow: '0 0 2px #0003',
        '& svg': {
            fill: theme.palette.action01,
        },
        ".attachment-container:hover &": {
            visibility: "visible",
        }
    },
}));
export const DownloadButton = ({ name, src }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    return (React.createElement("a", { href: src, download: name, className: classes.container, "aria-label": t('chat.media.download'), target: "_blank", rel: "noopener noreferrer" },
        React.createElement(Icon, { colorInClass: true, src: IconDownload, size: 14 })));
};
